class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    localStorage.removeItem("cartdrawer");
    // window.location.reload();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          var target = 50;
          //var target = $('.itg_progress_main').attr('ship_target');
          var cartTotal = cart.total_price;
          var final_price = cartTotal / 100;
          var pro = (final_price / target) * 100 + "%";
          var final_gift = (target - final_price).toFixed(2);
          //alert(pro)
          if (cart.item_count <= 0) {
            $(".itg_you_may").hide();
            $(".itg_progress_main").hide();
          }
          if (final_price < target) {
            $(".itg_progress_main .progress_text").html(
              'ONLY <span class="text_pro"> $' +
                final_gift +
                "</span> TO GO TO UNLOCK FREE US SHIPPING!"
            );
            $(".itg_progress_main .current_progress").css("width", pro);
          } else {
            $(".itg_progress_main .current_progress").css("width", "100%");
            $(".itg_progress_main .progress_text").html(
              "CONGRATS! YOU'VE UNLOCKED FREE US SHIPPING!"
            );
            $(".itg_you_may").show();
          }
        },
      });
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          var target = 100;
          //var target = $('.itg_progress_main').attr('ship_target');
          var cartTotal = cart.total_price;
          var final_price = cartTotal / 100;
          var pro = (final_price / target) * 100 + "%";
          var final_gift = (target - final_price).toFixed(2);
          //alert(pro)
          if (cart.item_count <= 0) {
            //$('.itg_you_may').hide();
            $(".itg_progress_main_gift").hide();
          }
          if (final_price < target) {
            $(".itg_progress_main_gift .progress_text_gift").html(
              'ONLY <span class="text_pro"> $' +
                final_gift +
                "</span>  TO GO TO UNLOCK FREE US SHIPPING!"
            );
            $(".itg_progress_main_gift .current_progress_gift").css(
              "width",
              pro
            );
            $(".itg_progress_main_gift .itg_free_gift_btn").attr(
              "disabled",
              true
            );
            $(".itg_progress_main_gift .itg_free_gift_btn").text("locked");
          } else {
            $(".itg_progress_main_gift .current_progress_gift").css(
              "width",
              "100%"
            );
            $(".itg_progress_main_gift .progress_text_gift").html(
              "CONGRATS! YOU'VE EARNED A FREE GIFT!"
            );
            //$('.itg_you_may').show();
            $(".itg_progress_main_gift .itg_free_gift_btn").removeAttr(
              "disabled"
            );
            $(".itg_progress_main_gift .itg_free_gift_btn").text("add");
            gift_addons();
          }

          function gift_addons() {
            var prodcut_handle = "gift-product";
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              "/products/" +
              prodcut_handle;
            $.ajax({
              url: newurl,
              type: "GET",
              dataType: "html",
              success: function (res) {
                $(document).find(".itg_gift_btn").html("");
                var product_data = $(res).find(".itg_main_form").html();
                $(document).find(".itg_gift_btn").html(product_data);
              },
            });
          }
        },
      });
      //upsell product slider on cart drawer
      if (window.innerWidth < 769) {
        var swiper = new Swiper(".itg_cart_upsell_slider", {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
